import React from 'react';
import theme from 'styles/theme';

interface SVGAttributeProps extends React.SVGAttributes<HTMLOrSVGElement> {
  width?: number;
  height?: number;
  color?: string;
}

const EyeIcon = ({
  width = 20,
  height = 20,
  color = theme.secondary,
  ...rest
}: SVGAttributeProps) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 16 16'
      fill='none'
      {...rest}
    >
      <path
        d='M7.99935 6C7.46892 6 6.96021 6.21071 6.58514 6.58579C6.21006 6.96086 5.99935 7.46957 5.99935 8C5.99935 8.53043 6.21006 9.03914 6.58514 9.41421C6.96021 9.78929 7.46892 10 7.99935 10C8.52978 10 9.03849 9.78929 9.41356 9.41421C9.78864 9.03914 9.99935 8.53043 9.99935 8C9.99935 7.46957 9.78864 6.96086 9.41356 6.58579C9.03849 6.21071 8.52978 6 7.99935 6ZM7.99935 11.3333C7.11529 11.3333 6.26745 10.9821 5.64233 10.357C5.01721 9.7319 4.66602 8.88406 4.66602 8C4.66602 7.11595 5.01721 6.2681 5.64233 5.64298C6.26745 5.01786 7.11529 4.66667 7.99935 4.66667C8.8834 4.66667 9.73125 5.01786 10.3564 5.64298C10.9815 6.2681 11.3327 7.11595 11.3327 8C11.3327 8.88406 10.9815 9.7319 10.3564 10.357C9.73125 10.9821 8.8834 11.3333 7.99935 11.3333ZM7.99935 3C4.66602 3 1.81935 5.07333 0.666016 8C1.81935 10.9267 4.66602 13 7.99935 13C11.3327 13 14.1793 10.9267 15.3327 8C14.1793 5.07333 11.3327 3 7.99935 3Z'
        fill={color}
      />
    </svg>
  );
};

export default EyeIcon;
